import React from 'react';
import { Flex } from 'rebass';
import Styled from 'styled-components';
import { Body1 } from '../FontStyles';
//import baseTheme from '../../themes/baseTheme';

const DefaultTableHeader = Styled(Flex)`


i {
  font-size: 15px;
}

`;

export default props => (
  <DefaultTableHeader width={1}>
    <Flex>
      <Body1>{props.children}</Body1>
    </Flex>
    <Flex flexWrap="wrap" alignItems="center" ml={3}>
      <Flex mb={-18} width={1}>
        <i class="material-icons up">expand_less</i>
      </Flex>
      <Flex mt={-18} width={1}>
        <i class="material-icons down">expand_more</i>
      </Flex>
    </Flex>
  </DefaultTableHeader>
);
